module.exports = __webpack_public_path__ + "img/LOGOS-138x40.a050f1fd.png";